import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { OnlyNumber, BlockCopyPasteDirective } from './directives'
import { AuthenticateService, WebsocketService, FlatStatusNotifierService, AuthGuardService } from './services';
import {
    HeaderComponent, FooterComponent
} from './layouts';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        HttpClientModule
    ],
    declarations: [HeaderComponent, FooterComponent, OnlyNumber,BlockCopyPasteDirective],
    providers: [AuthGuardService,AuthenticateService,WebsocketService, FlatStatusNotifierService],
    exports: [
        CommonModule,
        FormsModule,
        RouterModule,
        FooterComponent,
        HeaderComponent,
        OnlyNumber,
        BlockCopyPasteDirective
    ]
})
export class SharedModule { }
